import React, { Children } from 'react';
import Grid from '@mui/material/Grid2';
import PropTypes from 'prop-types';

export default function AuditionRecordingDetailsGrid({ children }) {
  const items = Children.toArray(children);

  return (
    (<Grid container spacing={0}>
      <Grid container spacing={2}>
        <Grid size={6}>{items[0]}</Grid>
        <Grid size={6}>{items[1]}</Grid>
      </Grid>
      <Grid size={12}>{items[2]}</Grid>
      <Grid size={12}>{items[3]}</Grid>
      <Grid size={12}>{items[4]}</Grid>
    </Grid>)
  );
}

AuditionRecordingDetailsGrid.propTypes = {
  children: PropTypes.node,
};
